import { createContext, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
    const [user, setUser] = useState(null); // null = checking, false = anon, object = user
    const [checking, setChecking] = useState(true);

    useEffect(() => {
        let mounted = true;
        api.get("/auth/me")
            .then((r) => mounted && setUser(r.data))
            .catch(() => mounted && setUser(false))
            .finally(() => mounted && setChecking(false));
        return () => {
            mounted = false;
        };
    }, []);

    const login = async (email, password) => {
        const { data } = await api.post("/auth/login", { email, password });
        if (data.access_token) localStorage.setItem("rr_token", data.access_token);
        setUser({ id: data.id, email: data.email, name: data.name, role: data.role });
        return data;
    };

    const logout = async () => {
        try {
            await api.post("/auth/logout");
        } catch {}
        localStorage.removeItem("rr_token");
        setUser(false);
    };

    return (
        <AuthContext.Provider value={{ user, checking, login, logout }}>
            {children}
        </AuthContext.Provider>
    );
}

export function useAuth() {
    return useContext(AuthContext);
}
